import dayjs from "dayjs";
import { FIELD_TYPE, FORMAT_TIME } from "types/enums";
import { DataFormField } from "types/models/input-field-type";

const { SELECT, COMBO_BOX, DATE_DISABLE_NO_DAY } = FIELD_TYPE;
const cssProps2 = {
  labelCol: { xs: 8, sm: 8, md: 8, lg: 24, xl: 24 },
  wrapperCol: { xs: 16, sm: 16, md: 18, lg: 24, xl: 24 },
  css: { xs: 24, sm: 24, md: 24, lg: 24, xl: 24 },
};
const dataTTAP: DataFormField[] = [
  {
    type: SELECT,
    name: "nguonBenhNhanList",
    mode: "multiple",
    label: "Chọn Nguồn bệnh nhân",
    placeholder: "Tất cả",
    ...cssProps2,
    disable: true,
    options: JSON.parse(localStorage.getItem("nguonBN")),
  },
  {
    type: COMBO_BOX,
    mode: "multiple",
    name: "loaiKCBList",
    label: "Chọn loại KCB",
    placeholder: "Tất cả",
    disable: true,
    ...cssProps2,
    options: JSON.parse(localStorage.getItem("loaiKCB")),
    // options: loaiKCB
  },
  {
    type: COMBO_BOX,
    name: "doiTuongList",
    placeholder: "Tất cả",
    mode: "multiple",
    options: JSON.parse(localStorage.getItem("doiTuong")),
    label: "Chọn Đối tượng",
    disable: true,
    ...cssProps2,
  },
  {
    type: DATE_DISABLE_NO_DAY,
    disableDate: false,
    //needConfirm:false,
    rules: [{ required: true, message: "Áp dụng từ là bắt buộc!" }],
    optionsTime: { format: FORMAT_TIME.dayFull, showTime: true },
    label: "Áp dụng từ",
    name: "ngayBatDau",
    labelCol: { xs: 8, sm: 8, md: 8, lg: 24, xl: 24 },
    wrapperCol: { xs: 16, sm: 16, md: 16, lg: 24, xl: 24 },
    disable: true,
    css: { xs: 24, sm: 24, md: 24, lg: 12, xl: 12 },
    // disabledDate: false,
  },
  {
    type: DATE_DISABLE_NO_DAY,
    disableDate: false,
    // needConfirm:false,
    rules: [{ required: true, message: "Áp dụng từ là bắt buộc!" }],
    optionsTime: { format: FORMAT_TIME.dayFull, showTime: true },
    label: "Áp dụng đến",
    name: "ngayKetThuc",
    labelCol: { xs: 8, sm: 8, md: 8, lg: 24, xl: 24 },
    wrapperCol: { xs: 16, sm: 16, md: 16, lg: 24, xl: 24 },
    css: { xs: 24, sm: 24, md: 24, lg: 12, xl: 12 },
    disable: true,
    // disabledDate: false,
  },
];
export { dataTTAP };
